<template>
    <Card>
        <template v-slot:header>
            <h2>近期趋势</h2>
            <span class="icon-info">&nbsp;</span>

            <div class="card-header-block">
                <el-radio-group v-model="days" size="mini" @change="changedDate">
                    <el-radio-button label="7">近7天</el-radio-button>
                    <el-radio-button label="14">近14天</el-radio-button>
                    <el-radio-button label="28">近28天</el-radio-button>
                </el-radio-group>
            </div>
            <SelectChartValueType @change="onTypeChanged"></SelectChartValueType>
        </template>
        <div class="card-content" ref="cardcontent">
            <ChartMap class="chart-normal" ref="chart"></ChartMap>
        </div>
    </Card>
</template>
<script>
import SelectChartValueType from "./SelectChartValueType.vue";
import ChartMap from "../../components/ChartMap.vue";
export default {
    name: "FlowWeather",
    components: {
        SelectChartValueType,
        ChartMap,
    },
    data() {
        return {
            days: 14,
            load1: false,
            load2: false,
            searchData: {
                EndTime: "",
                BeginTime: "",
                Date: "",
                EntityID: "",
                TotalType: 2,
            },
            searchData2: {
                EndTime: "",
                BeginTime: "",
                Date: "",
                EntityID: "",
                TotalType: 2,
            },
            type: "1",
            dataList1: [],
            dataList2: [],
        };
    },
    created() {
        this.searchData.BeginTime = new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 14)).format("yyyy-MM-dd");
        this.searchData.EndTime = new Date().format("yyyy-MM-dd");
        this.searchData2.BeginTime = new Date(new Date().setTime(new Date(this.searchData.BeginTime).getTime() - 3600 * 1000 * 24 * 7)).format(
            "yyyy-MM-dd"
        );
        this.searchData2.EndTime = new Date(new Date().setTime(new Date(this.searchData.EndTime).getTime() - 3600 * 1000 * 24 * 7)).format(
            "yyyy-MM-dd"
        );
    },
    mounted() {},
    methods: {
        onTypeChanged(type) {
            this.type = type;
            this.bindData();
        },
        changedDate() {
            this.searchData.BeginTime = new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * parseInt(this.days, 10))).format(
                "yyyy-MM-dd"
            );
            this.searchData.EndTime = new Date().format("yyyy-MM-dd");
            this.searchData2.BeginTime = new Date(new Date().setTime(new Date(this.searchData.BeginTime).getTime() - 3600 * 1000 * 24 * 7)).format(
                "yyyy-MM-dd"
            );
            this.searchData2.EndTime = new Date(new Date().setTime(new Date(this.searchData.EndTime).getTime() - 3600 * 1000 * 24 * 7)).format(
                "yyyy-MM-dd"
            );

            this.searchData.Date = this.searchData.BeginTime;
            this.searchData2.Date = this.searchData2.BeginTime;
            this.loadData();
        },
        setData(data) {
            this.searchData.Date = this.searchData.BeginTime;
            this.searchData.EntityID = data.ID;
            this.searchData2.Date = this.searchData2.BeginTime;
            this.searchData2.EntityID = data.ID;
            this.loadData();
        },
        loadData() {
            this.load1 = false;
            this.load2 = false;
            this.$ajax.post("/AnalyzeData/GetEntitySection", this.searchData).then((result) => {
                this.dataList1 = result.Data;
                this.load1 = true;
                if (this.load1 && this.load2) {
                    this.bindData();
                }
            });
            this.$ajax.post("/AnalyzeData/GetEntitySection", this.searchData2).then((result) => {
                this.dataList2 = result.Data;
                this.load2 = true;
                if (this.load1 && this.load2) {
                    this.bindData();
                }
            });
        },
        bindData() {
            let opt = this.getOptions();
            this.$refs.chart.setData(opt);
        },
        getTypeKey() {
            switch (this.type) {
                case "2":
                    return "FlowDensity";
                case "3":
                    return "Amount";
                case "4":
                    return "OrderRate";
                case "5":
                    return "Price";
                case "6":
                    return "Effect";
                default:
                    return "DataIn";
            }
        },
        getS1Name() {
            return "近" + this.days + "天";
        },
        getS2Name() {
            return "前" + this.days + "天";
        },
        getOptions() {
            let arrX = new Array();
            let d1 = new Array();
            let d2 = new Array();
            let max = 100;
            let key = this.getTypeKey();
            for (let i = 0; i < this.dataList1.length; i++) {
                arrX.push(this.dataList1[i].Name);
                d1.push(this.dataList1[i][key]);
                d2.push(this.dataList2[i][key]);
                max = Math.max(max, this.dataList1[i][key], this.dataList2[i][key]);
            }
            let arrS = [
                {
                    name: this.getS1Name(),
                    data: d1,
                    type: "line",
                    smooth: true,
                    areaStyle: {},
                    itemStyle: {
                        normal: {
                            color: "#56a1f8",
                        },
                    },
                },
                {
                    name: this.getS2Name(),
                    data: d2,
                    type: "line",
                    smooth: true,
                    areaStyle: {},
                    itemStyle: {
                        normal: {
                            color: "#57bf8d",
                        },
                    },
                },
            ];
            let x = this.getxAxis(arrX);
            return {
                grid: {
                    top: 40,
                    left: 50,
                    right: 20,
                    bottom: 40,
                    borderColor: "#f3f3f3",
                },
                xAxis: x,
                yAxis: {
                    type: "value",
                    max: max,
                    axisLabel: {
                        formatter: "{value}",
                    },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                series: arrS,
                legend: {
                    data: [this.getS1Name(), this.getS2Name()],
                    bottom: "0px",
                },
            };
        },
        getxAxis(data) {
            return {
                type: "category",
                axisLabel: {
                    // rotate: 45,
                },
                axisPointer: {
                    type: "shadow",
                },
                axisLine: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                data: data,
            };
        },
    },
};
</script>
